import React, { Component } from 'react';

import { observer } from 'mobx-react';

import membershipStore from '../../../stores/membershipStore';
import { T } from '../../../stores/textStore';
import { loadPromotion } from '../../../actions/membershipActions';


class Cart extends Component {    
    PAYMENT_FREQUENCY_NOUN_DISPLAY = {
        'monthly': 'month',
        'annual': 'year'
    }

	handleCouponChange = (event) => {
        event.preventDefault();    
        membershipStore.promoCode.set(event.target.value);
    }

	handleCouponSubmit = (event) => {
        event.preventDefault();
        loadPromotion();
    }    

    renderBillingNotes() {
        const current = membershipStore.getCurrentUserSubscription();
        const target = 
            membershipStore.getMembershipBySlug(membershipStore.changeForm.get('membership'));        
        if (target.level < current.subscription.membership.level) {
            return (
                <small>
                    {T('Your new')} <strong>{target.name}</strong> {T('membership plan will take effect on')}
                    &nbsp;{current.next_payment_date} {T('at the end of your current')}&nbsp;
                    <strong>{current.subscription.membership.name}</strong> {T("plan's billing cycle.")}
                </small>
            );
        }      
        if (false && membershipStore.isTrialMode()) {
            return (
                <small>
                    {T('Your new')} <strong>{target.name}</strong> {T('membership plan will take effect')}
                    {T('immediately. Your trial period ends in 30 days, during which you can cancelanytime. After your trial period ends, your credit card will be charged for the full price of your membership.')}
                </small>
            );            
        }  
        if (current.subscription.membership.level < target.level) {
            return (
                <small>                    
                    {T("After any free trial(s) and/or discount(s), you will be charged the amount listed above on a recurring basis. If you do not cancel during the free trial period, you will be charged and your membership will continue until you cancel.")}
                </small>
            );
        }
    }

    renderCouponForm() {
        if (membershipStore.isTrialMode()) {
            return null;
        }
        return (
            <span>
                <form className="card p-2 bg-light border-secondary">
                    <div className="input-group">
                        <input 				
                            type="text" 
                            className="form-control border-secondary"
                            name='coupon' 
                            placeholder={T('Promo code')}
                            value={membershipStore.promoCode.get()} 
                            onChange={this.handleCouponChange}
                        />
                        <div className="input-group-append">
                            <button 
                                type="submit" 
                                className="btn btn-secondary" 
                                onClick={this.handleCouponSubmit}																						
                            >
                                {T('Apply')}
                            </button> 
                        </div>                    
                    </div>
                </form>   
                {!membershipStore.prmotionAppliedSuccessfully.get() &&
                    <p className="text-danger">
                        {membershipStore.promotionErrorMessage.get()}
                    </p>   
                }
                {membershipStore.prmotionAppliedSuccessfully.get() &&
                    <p className="text-success">
                        {T('The promo code was successfully applied to your cart.')}
                    </p>   
                }             
            </span>      
        );     
    }    

    render() {
        //console.log('XXXX', membershipStore.changeForm.get('membership'));
        const membership = 
            membershipStore.getMembershipBySlug(membershipStore.changeForm.get('membership'));
        const paymentFrequency = membershipStore.changeForm.get('payment_frequency');
        const promotion = membershipStore.getPromotion();
        return (
            <span>                
                <h4 className="d-flex justify-content-between align-items-center mb-3">
                    <span className="text-muted">{T('Your Cart')}</span>
                </h4>
                <ul className="list-group mb-3">
                    <li className="list-group-item d-flex justify-content-between lh-condensed">
                        <div>                             
                            <h6 className="my-0">
                                {membership.name} {T('Membership')}
                            </h6>
                            <small className="text-muted">
                                {paymentFrequency} {T('plan')}
                            </small>
                        </div>
                        <span className="text-muted">
                            {membershipStore.getChangeFormTotal().display}
                        </span>
                    </li>  
                    {/*!membershipStore.isTrialMode() &&*/ !promotion &&
                        <li className="list-group-item d-flex justify-content-between">
                            <span>{T('Total')}</span>
                            <strong>
                                {membershipStore.defactoCurrency.symbol}{membershipStore.getChangeFormTotal()}/
                                {T(this.PAYMENT_FREQUENCY_NOUN_DISPLAY[paymentFrequency])}
                            </strong>
                        </li>
                    }
                    {/*!membershipStore.isTrialMode() &&*/ promotion &&
                    <span>
                        <li className="list-group-item d-flex justify-content-between">
                            <span>{T('Subtotal')}</span>
                            <strong>
                                {membershipStore.defactoCurrency.symbol}{membershipStore.getChangeFormSubtotal()}/
                                {T(this.PAYMENT_FREQUENCY_NOUN_DISPLAY[paymentFrequency])}
                            </strong>
                        </li>
                        <li className="list-group-item d-flex justify-content-between">
                            <span>{T('Promotion')}</span>
                            <span className="text-right">
                                <h3 className="text-success mb-0">
                                    {promotion.initial ?
                                        <span>
                                            {membershipStore.defactoCurrency.symbol}{promotion.initial}
                                        </span>
                                        :
                                        <span>{Math.round(promotion.discount_percent)}% {T('off')}</span>
                                    }
                                </h3> 
                                {promotion.discount_duration &&
                                    <span className="mt-0">
                                        {T('for')} {promotion.discount_duration} {promotion.duration_units_label}
                                    </span>                        
                                }      
                            </span>                                                        
                        </li>  
                        <li className="list-group-item d-flex justify-content-between">
                            <span>{T('Total')}</span>
                            <span className="text-right">   
                                {promotion.initial ?                         
                                    <strong>
                                        {membershipStore.defactoCurrency.symbol}{promotion.initial}/
                                        {T('one-time')}
                                    </strong>
                                    :
                                    <strong>
                                        {membershipStore.defactoCurrency.symbol}{membershipStore.getChangeFormTotal()}/
                                        {T(this.PAYMENT_FREQUENCY_NOUN_DISPLAY.monthly)}
                                    </strong>                                    
                                }
                                <br />
                                {promotion.discount_duration &&
                                    <small>
                                        {membershipStore.defactoCurrency.symbol}{membershipStore.getChangeFormSubtotal()}/
                                        {T(this.PAYMENT_FREQUENCY_NOUN_DISPLAY[paymentFrequency])}
                                        &nbsp;{T('after')} {promotion.discount_duration} {promotion.duration_units_label}
                                    </small>  
                                }
                            </span>                        
                        </li>                        
                    </span>                      
                    }                    
                    {false && membershipStore.isTrialMode() &&
                    <li className="list-group-item d-flex justify-content-between">
                        <span>{T('Total')} ({membershipStore.defactoCurrency.code})</span>
                        <span className="text-right">
                            <h3 className="text-success">
                                {membershipStore.defactoCurrency.symbol}0
                            </h3> 
                            <strong>{T('for the first 30 days')}</strong>
                            <br />
                            <small>
                                {membershipStore.defactoCurrency.symbol}{membershipStore.getChangeFormTotal()}/
                                {T(this.PAYMENT_FREQUENCY_NOUN_DISPLAY[paymentFrequency])}
                                &nbsp;{T('after 30 days')}
                            </small>
                        </span>
                    </li>
                    }
                    <li className="list-group-item d-flex justify-content-between">
                        {this.renderBillingNotes()}
                    </li>                    
                    {/*
                    <li className="list-group-item d-none d-lg-flex justify-content-between">                            
                            <ul className="list-unstyled">
                                <div className="text-center"><u>{T('Plan Features')}</u></div>
                                {membership.features_as_list.map(feature =>
                                    <li className="my-1" key={feature}>
                                        <span className="ic-check tkc-text-red"></span>
                                        {feature}
                                    </li>
                                )}
                            </ul>
                    </li>                    
                    */}
                </ul>       
                <div className="mb-4">{this.renderCouponForm()}</div>           
            </span>
        );
    }

}

export default observer(Cart);



// WEBPACK FOOTER //
// ./src/views/membership/components/Cart.js